
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.948 12.938l-1.546 1.526L7.5 9.058l-5.876 5.406-1.572-1.526 5.593-5.681L0 1.551 1.572 0 7.5 5.455 13.428 0 15 1.551 9.355 7.257l5.593 5.681z","fill-rule":"nonzero"}})])
          )
        }
      }
    